import { ApiResponse } from '../api'
import { axios } from '@src/lib/axios'

export interface GetSfxsReqDto {
  uuid: string;
}
  
export interface SfxItemDto {
  uuid: string;
  sfxNo: string;
  description: string;
}

export type SfxsRespDto = SfxItemDto[]

/** 依車種取得sfx清單 */
export async function getSfxs(reqDto: GetSfxsReqDto): Promise<SfxsRespDto> {
  const { uuid } = reqDto
  const response = await axios.get<ApiResponse<SfxsRespDto>>(`/api/web/cars/sfxes/${uuid}`)

  return response.data
}
  
export interface BrandItemDto {
  uuid: string;
  status: string;
  description: string;
  code: string;
}

export type CarBrandsRespDto = BrandItemDto[]

/** 取得品牌清單 */
export async function getCarBrands(): Promise<CarBrandsRespDto> {
  const response = await axios.get<ApiResponse<CarBrandsRespDto>>(`/api/web/cars/car-brands`)

  return response.data
}


export interface GetCarModelsByCarBrandReqDto {
  uuid: string;
}
  
export interface ModelItemDto {
  uuid: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  description: string;
  code: string;
  modelYear: string;
  carBrandUuid: string;
}

export type CarModelsByCarBrandRespDto = ModelItemDto[]

/** 依品牌取得車種清單 */
export async function getCarModelsByCarBrand(reqDto: GetCarModelsByCarBrandReqDto): Promise<CarModelsByCarBrandRespDto> {
  const { uuid } = reqDto
  const response = await axios.get<ApiResponse<CarModelsByCarBrandRespDto>>(`/api/web/cars/car-models/${uuid}`)

  return response.data
}

export interface PartItemDto {
  uuid: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  description: string;
  code: string;
}

export type CarPartsRespDto = PartItemDto[]

/** 取得組裝部位清單 */
export async function getCarParts(): Promise<CarPartsRespDto> {
  const response = await axios.get<ApiResponse<CarPartsRespDto>>(`/api/web/cars/car-parts`)

  return response.data
}

export interface PioArgDto {
  uuid: string;
  fieldName: string;
  description: string;
}

export interface PioItemDto {
  uuid: string;
  code: string;
  description: string;
  pioItemArguments: PioArgDto[];
}

export type PioItemsRespDto = PioItemDto[]

/** 取得PIO清單 */
export async function getPioItems(): Promise<PioItemsRespDto> {
  const response = await axios.get<ApiResponse<PioItemsRespDto>>(`/api/web/cars/pio-items`)

  return response.data
}

export interface CarModelDto {
  uuid: string;
  description: string;
  code: string;
}

export type CarModelsRespDto = CarModelDto[]

export async function getCarModels(): Promise<CarModelsRespDto> {
  const response = await axios.get<ApiResponse<CarModelsRespDto>>(`/api/web/cars/active-car-models`)

  return response.data
}
